var map = {
	"./apple-touch-icon-retina.png": 1721,
	"./apple-touch-icon.png": 1722,
	"./chatdesk-logo.png": 1723,
	"./chatdesk_video_thumbnail.png": 741,
	"./check-mark.png": 1724,
	"./delighted.png": 1725,
	"./facebook.png": 701,
	"./favicon16.png": 1726,
	"./favicon32.png": 1727,
	"./favicon48.png": 1728,
	"./front.png": 704,
	"./gladly.png": 1729,
	"./gorgias.png": 1730,
	"./helpscout.png": 705,
	"./icon_business.png": 242,
	"./icon_gladly.png": 742,
	"./icon_gorgias.png": 743,
	"./icon_lock.png": 1731,
	"./icon_reamaze.png": 744,
	"./icon_shopify.png": 745,
	"./icon_status_green.png": 746,
	"./icon_status_red.png": 747,
	"./icon_status_yellow.png": 748,
	"./icon_twitter.png": 1732,
	"./icons/icon_thumbs_up.png": 749,
	"./instagram.png": 702,
	"./kustomer.png": 750,
	"./live_agent.png": 1733,
	"./logos/logo_dixa.png": 515,
	"./logos/logo_reamaze.png": 339,
	"./logos/logo_tiktok_shop.png": 516,
	"./no-image-rect.png": 1734,
	"./no-image.png": 1735,
	"./profile_pic_grace.png": 1736,
	"./profile_pic_tara.png": 751,
	"./reamaze.png": 1737,
	"./salesforce_service_cloud.png": 1738,
	"./shopify.png": 1739,
	"./skin/database_add.png": 1740,
	"./skin/database_delete.png": 1741,
	"./skin/database_edit.png": 1742,
	"./skin/database_save.png": 1743,
	"./skin/database_table.png": 1744,
	"./skin/exclamation.png": 1745,
	"./skin/house.png": 1746,
	"./skin/information.png": 1747,
	"./stamped.png": 1748,
	"./tick.png": 1749,
	"./tiktok.png": 706,
	"./twitter.png": 700,
	"./yotpo.png": 1750,
	"./zendesk-chat.png": 752
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1720;